import { FileText, CheckCircle, Clock, XCircle, Archive, AlertCircle } from 'lucide-react';

export default function StatsCard({ title, value, icon: Icon, color, trend }) {
    const colors = {
        blue: 'bg-blue-50 text-blue-600 border-blue-100',
        green: 'bg-green-50 text-green-600 border-green-100',
        yellow: 'bg-yellow-50 text-yellow-600 border-yellow-100',
        red: 'bg-red-50 text-red-600 border-red-100',
        purple: 'bg-purple-50 text-purple-600 border-purple-100',
    };

    const colorClass = colors[color] || colors.blue;

    return (
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between">
                <div>
                    <p className="text-sm font-medium text-gray-500 mb-1">{title}</p>
                    <h3 className="text-2xl font-bold text-gray-900">{value}</h3>
                </div>
                <div className={`p-3 rounded-xl ${colorClass}`}>
                    <Icon className="w-6 h-6" />
                </div>
            </div>
            {trend && (
                <div className="mt-4 flex items-center text-xs">
                    <span className="text-green-500 font-medium flex items-center">
                        +{trend}%
                    </span>
                    <span className="text-gray-400 ml-2">с прошлого месяца</span>
                </div>
            )}
        </div>
    );
}
